import { render, staticRenderFns } from "./birthday.vue?vue&type=template&id=ce21f1be&scoped=true&"
import script from "./birthday.vue?vue&type=script&lang=js&"
export * from "./birthday.vue?vue&type=script&lang=js&"
import style0 from "./birthday.vue?vue&type=style&index=0&id=ce21f1be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce21f1be",
  null
  
)

export default component.exports